import * as _ from "lodash-es";
import React, { ChangeEvent, useContext, useEffect, useMemo, useRef, useState } from "react";
import { FormattedNumber } from "react-intl";
import Modal from "react-modal";
import IGetAllSupplierTokensDTO from "../../../models/DTO/IGetAllSupplierTokensDTO";
import IGetCatalogCSVInventoryDTO from "../../../models/DTO/IGetCatalogCSVInventoryDTO";
import IGetCatalogsDTO from "../../../models/DTO/IGetCatalogsDTO";
import IGetStockLevelsDTO from "../../../models/DTO/IGetStockLevelsDTO";
import IOnGetCatalogCSVInventoryDTO from "../../../models/DTO/IOnGetCatalogCSVInventoryDTO";
import IOnGetCatalogsDTO from "../../../models/DTO/IOnGetCatalogsDTO";
import IOnGetPriceGroupsDTO from "../../../models/DTO/IOnGetPriceGroupsDTO";
import IOnGetStockLevelsDTO from "../../../models/DTO/IOnGetStockLevelsDTO";
import IOnPerformCatalogCSVInventoryUpdateDTO from "../../../models/DTO/IOnPerformCatalogCSVInventoryUpdateDTO";
import IPerformCatalogCSVInventoryUpdateDTO from "../../../models/DTO/IPerformCatalogCSVInventoryUpdateDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import ICatalog from "../../../models/ICatalog";
import ICatalog_Item from "../../../models/ICatalog_Item";
import ICatalog_ItemUI from "../../../models/ICatalog_ItemUI";
import ICatalogCSVInventoryDataRow from "../../../models/ICatalogCSVInventoryDataRow";
import IImageSizeEnum from "../../../models/IImageSizeEnum";
import IInventoryRowConfig from "../../../models/IInventoryRowConfig";
import INotification from "../../../models/INotification";
import InventoryActionEnum from "../../../models/InventoryActionEnum";
import InventoryRowColPropertyEnum from "../../../models/InventoryRowColPropertyEnum";
import InventoryUpdateReferenceColEnum from "../../../models/InventoryUpdateReferenceColEnum";
import IOwTableCols from "../../../models/IOwTableCols";
import IOwTableConfig from "../../../models/IOwTableConfig";
import IPrice_Group from "../../../models/IPrice_Group";
import IVendorModel from "../../../models/IVendorModel";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import OrderEntryService from "../../../services/OrderEntryService";
import UIService from "../../../services/UIService";
import UserService from "../../../services/UserService";

import ViewAccessService from "../../../services/ViewAccessService";
import CatalogUploadUpdateModal from "../../catalogs/Catalogs/CatalogUploadUpdateModal/CatalogUploadUpdateModal";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import OwButton from "../../shared/OwButton/OwButton";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import { OwInventoryAdjustment } from "../../shared/OwInventoryAdjustment/OwInventoryAdjustment";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwS3ImageViewer from "../../shared/OwS3ImageViewer/OwS3ImageViewer";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import OwHierarchicalCategorySelector from "../../shared/OwHierarchicalCategorySelector/OwHierarchicalCategorySelector";
import OwTable from "../../shared/OwTable/OwTable";
import OwTitle from "../../shared/OwTitle/OwTitle";
import PaginationBar from "../../shared/PaginationBar/PaginationBar";
import InventoryCartSidebar from "../InventoryCartSidebar/InventoryCartSidebar";

import IOnGetWarehousesDTO from "../../../models/DTO/IOnGetWarehousesDTO";
import IWarehouse from "../../../models/IWarehouse";
import IWarehouse_Catalog_Items_Map from "../../../models/IWarehouse_Catalog_Items_Map";
import IGetWarehousesDTO from "../../../models/DTO/IGetWarehousesDTO";
import IAdjustWarehouseInventoryDTO from "../../../models/DTO/IAdjustWarehouseInventoryDTO";
import IOnAdjustWarehouseInventoryDTO from "../../../models/DTO/IOnAdjustWarehouseInventoryDTO";
import OwToggle from "../../shared/OwToggle/OwToggle";
import { QtyOnHandValue } from "../../shared/QtyOnHandValue/QtyOnHandValue";
import SortOrderEnum from "../../../models/SortOrderEnum";
import IOrder from "../../../models/IOrder";
import IGetCategoriesDTO from "../../../models/DTO/IGetCategoriesDTO";
import { Dropdown } from "react-bootstrap";
import IOnGetCategoriesDTO from "../../../models/DTO/IOnGetCategoriesDTO";
import ICategory from "../../../models/ICategory";
import { InventoryMobileRows } from "../InventoryMobileRows/InventoryMobileRows";
import { InventoryItemMobileDetailView } from "../InventoryItemMobileDetailView/InventoryItemMobileDetailView";
import { NumericFormat } from "react-number-format";
import { DescriptionExpander } from "../../shared/DescriptionExpander/DescriptionExpander";
import OwPill from "../../shared/OwPill/OwPill";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import { InventoryAccountSelection } from "../InventoryAccountSelection/InventoryAccountSelection";
import { InventoryItemAddDetail } from "./InventoryItemAddDetail/InventoryItemAddDetail";
import { useNavigate } from "react-router-dom";
import UserTypesEnum from "../../../models/UserTypesEnum";
import { SearchSection } from "../../shared/SearchSection/SearchSection";
import { InventoryByCustomerView } from "../InventoryByCustomerView/InventoryByCustomerView";
import { ControlBar } from "@components/shared/ControlBar/ControlBar";
import { ClickToCopy } from "@components/shared/ClickToCopy/ClickToCopy";
import { useAppContextNonNull } from "@contexts/AppContext";
import { buildAuthHeadersForFetch, buildRestUrl } from "@services/RestService";
import RestEndpointsEnum from "@models/RestEndpointsEnum";
import OwTranslate from "@components/shared/OwTranslate/OwTranslate";
import OwActionBar from "@components/shared/OwActionBar/OwActionBar";
import IColumns from "@models/IColumns";
import IUpdateTokenSettingsDTO from "@models/DTO/IUpdateTokenSettingsDTO";
import IOnUpdateTokenSettingsDTO from "@models/DTO/IOnUpdateTokenSettingsDTO";
import { OwFnInput } from "@components/shared/OwFnInput/OwFnInput";
import IPriceRangeFilter from "@models/IPriceRangeFilter";
import ScreenOptionsEnum from "@models/ScreenOptionsEnum";
import { hasEditAccess } from "@services/ScreenOptionsService";
import { OwIconButton } from "@components/shared/OwIconButton/OwIconButton";
import { InventoryItemReservedQtyOnHandDetailSidebar } from "../InventoryItemReservedQtyOnHandDetailSidebar/InventoryItemReservedQtyOnHandDetailSidebar";
import { InventoryItemBackorderedQtyDetailSidebar } from "../InventoryItemBackorderedQtyDetailSidebar/InventoryItemBackorderedQtyDetailSidebar";
import { InventoryItemIncomingQtyDetailSidebar } from "../InventoryItemIncomingQtyDetailSidebar/InventoryItemIncomingQtyDetailSidebar";
import { InventoryItemInProductionDetailSidebar } from "../InventoryItemInProductionDetailSidebar/InventoryItemInProductionDetailSidebar";

type Props = {};

export const Inventory = (props: Props) => {
    const { supplierModel, userModel, vendorModel, socket, uiContext } = useAppContextNonNull();
    const navigate = useNavigate();

    const isReadOnly = useMemo(() => {
        return !hasEditAccess(ScreenOptionsEnum.INVENTORY, userModel, supplierModel, ViewAccessService.Inventory);
    }, [userModel, supplierModel]);

    const getColumnChecked = (objProp: string, defaultVal: boolean) => {
        let isChecked = defaultVal;

        const token = userModel.supplierUserToken || userModel.vendorUserToken;

        if (!_.isNil(token) && !_.isNil(token.settings?.inventory_cols) && !_.isNil(token.settings.inventory_cols[objProp])) {
            isChecked = token.settings.inventory_cols[objProp].isChecked;
        }

        return isChecked;
    };

    const getDefaultInventoryRowConfig = (): IInventoryRowConfig[] => {
        return [
            {
                property: InventoryRowColPropertyEnum.ACTIONS,
                sequence: 1,
                func: "",
            },
            {
                property: InventoryRowColPropertyEnum.NAME,
                sequence: 2,
                func: "",
            },
            {
                property: InventoryRowColPropertyEnum.SKU,
                sequence: 3,
                func: "",
            },
            {
                property: InventoryRowColPropertyEnum.DESCRIPTION,
                sequence: 4,
                func: "",
            },
            {
                property: InventoryRowColPropertyEnum.MSRP,
                sequence: 5,
                func: "",
            },
            {
                property: InventoryRowColPropertyEnum.PRICE_GROUP,
                sequence: 6,
                func: "",
            },
            {
                property: InventoryRowColPropertyEnum.UOM,
                sequence: 7,
                func: "",
            },
            {
                property: InventoryRowColPropertyEnum.TOTAL_QTY_ON_HAND,
                sequence: 8,
                func: "",
                isSupplier: true,
            },
            {
                property: InventoryRowColPropertyEnum.QTY_ON_HAND,
                sequence: 8,
                func: "",
            },
            {
                property: InventoryRowColPropertyEnum.QTY_IN_PRODUCTION,
                sequence: 9,
                func: "",
                isSupplier: true,
            },
            {
                property: InventoryRowColPropertyEnum.RESERVED_QTY_ON_HAND,
                sequence: 9,
                func: "",
            },
            {
                property: InventoryRowColPropertyEnum.QTY_INCOMING,
                sequence: 10,
                func: "",
                isSupplier: true,
            },
            {
                property: InventoryRowColPropertyEnum.QTY_BACKORDERED,
                sequence: 11,
                func: "",
            },
            {
                property: InventoryRowColPropertyEnum.QTY_HELD_FOR_BACKORDERS,
                sequence: 12,
                func: "",
            },
            {
                property: InventoryRowColPropertyEnum.BACKORDER_LIMIT,
                sequence: 13,
                func: "",
            },
            {
                property: InventoryRowColPropertyEnum.LOCATION,
                sequence: 14,
                func: "",
            },
        ];
    };

    // Catalogs with a stored inventory_row_config predate the In Production
    // column; splice it in after Available so it isn't silently dropped.
    const ensureInProductionInRowConfig = (config: IInventoryRowConfig[]): IInventoryRowConfig[] => {
        if (config.some((col) => col.property === InventoryRowColPropertyEnum.QTY_IN_PRODUCTION)) {
            return config;
        }

        const result = [...config];
        const onHandIndex = result.findIndex((col) => col.property === InventoryRowColPropertyEnum.QTY_ON_HAND);
        result.splice(onHandIndex + 1, 0, {
            property: InventoryRowColPropertyEnum.QTY_IN_PRODUCTION,
            sequence: 9,
            func: "",
            isSupplier: true,
        });

        return result;
    };

    const getColumns = (catalog?: ICatalog) => {
        const allColumns: IColumns = {
            name: {
                name: "name",
                label: "name",
                isChecked: getColumnChecked("name", true),
                notVisible: false,
            },
            sku: {
                name: "sku",
                label: "sku",
                isChecked: getColumnChecked("sku", true),
                notVisible: false,
            },
            description: {
                name: "description",
                label: "description",
                isChecked: getColumnChecked("description", true),
                notVisible: false,
            },
            msrp: {
                name: "msrp",
                label: "msrp",
                isChecked: getColumnChecked("msrp", true),
                notVisible: false,
            },
            price_group: {
                name: "price_group",
                label: "price_group",
                isChecked: getColumnChecked("price_group", true),
                notVisible: false,
            },
            uom: {
                name: "uom",
                label: "uom",
                isChecked: getColumnChecked("uom", true),
                notVisible: false,
            },
            total_qty_on_hand: {
                name: "total_qty_on_hand",
                label: "total_on_hand",
                isChecked: getColumnChecked("total_qty_on_hand", true),
                notVisible: !userModel.isSupplierUser,
            },
            qty_on_hand: {
                name: "qty_on_hand",
                label: "available",
                isChecked: getColumnChecked("qty_on_hand", true),
                notVisible: false,
            },
            qty_in_production: {
                name: "qty_in_production",
                label: "in_production",
                isChecked: getColumnChecked("qty_in_production", true),
                notVisible: !userModel.isSupplierUser || !supplierModel.has_serials || !supplierModel.has_serial_production,
            },
            reserved_qty_on_hand: {
                name: "reserved_qty_on_hand",
                label: "reserved",
                isChecked: getColumnChecked("reserved_qty_on_hand", true),
                notVisible: !userModel.isSupplierUser,
            },
            qty_backordered: {
                name: "qty_backordered",
                label: "backordered",
                isChecked: getColumnChecked("qty_backordered", true),
                notVisible: !userModel.isSupplierUser,
            },
            qty_held_for_backorders: {
                name: "qty_held_for_backorders",
                label: "held_for_backorders",
                isChecked: getColumnChecked("qty_held_for_backorders", true),
                notVisible: !userModel.isSupplierUser,
            },
            backorder_limit: {
                name: "backorder_limit",
                label: "backorder_limit",
                isChecked: getColumnChecked("backorder_limit", true),
                notVisible: !userModel.isSupplierUser,
            },
            location: {
                name: "location",
                label: "location",
                isChecked: getColumnChecked("location", true),
                notVisible: !userModel.isSupplierUser,
            },
            qty_incoming: {
                name: "qty_incoming",
                label: "incoming",
                isChecked: getColumnChecked("qty_incoming", true),
                notVisible: !userModel.isSupplierUser,
            },
            last_updated: {
                name: "last_updated",
                label: "last_updated",
                isChecked: getColumnChecked("last_updated", true),
                notVisible: false,
            },
            pack: {
                name: "pack",
                label: "pack",
                isChecked: getColumnChecked("pack", true),
                notVisible: false,
            },
            purchase_link: {
                name: "purchase_link",
                label: "purchase_link",
                isChecked: getColumnChecked("purchase_link", true),
                notVisible: !userModel.isSupplierUser,
            },
            map: {
                name: "map",
                label: "map",
                isChecked: getColumnChecked("map", true),
                notVisible: !userModel.isSupplierUser,
            },
        };

        // we want to only show the columns that the supplier has setup for the catalog as visible.
        let inventory_row_config: IInventoryRowConfig[] = [];

        if (catalog) {
            inventory_row_config = catalog.inventory_row_config || getDefaultInventoryRowConfig();
        } else {
            inventory_row_config = getDefaultInventoryRowConfig();
        }

        inventory_row_config = ensureInProductionInRowConfig(inventory_row_config);

        const columns: IColumns = {};

        // with the inventory row config we need to compile the columns.
        for (const col of inventory_row_config) {
            if (allColumns[col.property]) {
                columns[col.property] = allColumns[col.property];
            }
        }

        return columns;
    };

    const [viewColumns, setViewColumns] = useState<IColumns>(getColumns());
    const [priceRangeStart, setPriceRangeStart] = useState<number | null>(null);
    const [priceRangeEnd, setPriceRangeEnd] = useState<number | null>(null);

    const onGetCategories = (data: IOnGetCategoriesDTO) => {
        setCategories(data.categories);
    };

    const onGetPriceGroups = (data: IOnGetPriceGroupsDTO) => {
        setPriceGroups(data.priceGroups);
    };

    const onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        if (isModalOpen) {
            return;
        }

        let _catalogs = data.catalogs;

        if (vendorModel) {
            if (vendorModel.lock_catalog_id) {
                if (vendorModel.Catalog) {
                    _catalogs = [vendorModel.Catalog];
                } else {
                    _catalogs = catalogs.filter((_catalog) => {
                        return _catalog.id === vendorModel.lock_catalog_id;
                    });
                }
            }
        }

        if (userModel.isSupplierUser && userModel.supplierUserToken?.catalog_id) {
            _catalogs = _catalogs.filter((_catalog) => {
                return _catalog.id === userModel.supplierUserToken?.catalog_id;
            });
        }

        let initialCatalog = _catalogs[0];

        if (supplierModel.default_order_catalog_id) {
            for (const catalog of _catalogs) {
                if (catalog.id === supplierModel.default_order_catalog_id) {
                    initialCatalog = catalog;
                    break;
                }
            }
        }

        if (initialCatalog) {
            setCatalogs(_catalogs);
            setCatalogGuid(initialCatalog.guid);
            setCatalog(initialCatalog);
            if (initialCatalog.Price_Groups) {
                setPriceGroups(initialCatalog.Price_Groups);
            }
            setupTableColumns();
        }
    };

    const onGetWarehouses = (data: IOnGetWarehousesDTO) => {
        setWarehouses(data.warehouses);
    };

    const onGetCatalogCSVInventory = (data: IOnGetCatalogCSVInventoryDTO) => {
        if (data) {
            UIService.downloadCSVData(data.csvData, data.filename);
        }

        setActiveInventoryCsvBtn(false);
    };

    const onGetStockLevels = (data: IOnGetStockLevelsDTO) => {
        const _catalogItems: ICatalog_ItemUI[] = [];

        const _tableConfig = { ...tableConfig };
        const _tableCols = [...columns];

        for (const catItem of data.catalogItems) {
            if (catItem.has_alternate_sourcing) {
                _tableConfig.hasDetailView = true;
                tableConfig.detailViewFullWidth = true;
                _tableCols[0].hasChevron = true;
                _tableCols[0].showChevronFn = showChevronFn;
            }

            if (!catItem.is_alternate_source) {
                const newItem: ICatalog_ItemUI = catItem as ICatalog_ItemUI;

                for (const cartItem of cartItems) {
                    if (cartItem.guid === newItem.guid) {
                        newItem.qty = cartItem.qty;
                        newItem.addedItem = cartItem.addedItem;
                    }
                }

                if (newItem.sku?.toLowerCase() === capturedScanValue.toLowerCase() && scanMode) {
                    newItem.editMode = true;
                }

                _catalogItems.push(newItem);
            }
        }

        // console.log("catalogItems: ", _catalogItems);

        setCatalogItems(_catalogItems);
        setTotalCatalogItems(data.totalCatalogItems);
        setStockLevelsBtnActive(false);
        setIsDataFetching(false);
        setIsInitialData(false);
        setDoScanSearch(false);
        // setTableConfig(_tableConfig);
        // setColumns(_tableCols);

        if (_catalogItems.length === 1 && showMobileItemView) {
            showItemDetailView(_catalogItems[0]);
        }
    };

    const notify = () => {
        setActiveInventoryCsvBtn(false);
    };

    const onPerformCatalogCSVInventoryUpdate = (data: IOnPerformCatalogCSVInventoryUpdateDTO) => {
        if (data) {
            getStockLevels("onPerformCatalogCSVInventoryUpdate");
        }
    };

    const onUpdateTokenSettings = (data: IOnUpdateTokenSettingsDTO) => {
        const notification: INotification = {
            message: "successfully_updated_settings",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        uiContext.notifyFn(null, notification);
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.CatalogsOnGetCatalogs, fn: onGetCatalogs },
        { endpoint: EndpointsEnum.CatalogsOnGetStockLevels, fn: onGetStockLevels },
        { endpoint: EndpointsEnum.CatalogsOnGetCatalogCSVInventory, fn: onGetCatalogCSVInventory },
        { endpoint: EndpointsEnum.CatalogsOnPerformCatalogCSVInventoryUpdate, fn: onPerformCatalogCSVInventoryUpdate },
        { endpoint: EndpointsEnum.Notify, fn: notify },
        { endpoint: EndpointsEnum.CatalogsOnGetPriceGroups, fn: onGetPriceGroups },
        { endpoint: EndpointsEnum.WarehouseOnGetWarehouses, fn: onGetWarehouses },
        // { endpoint: EndpointsEnum.WarehouseOnAdjustWarehouseInventory, fn: onAdjustWarehouseInventory },
        { endpoint: EndpointsEnum.CategoriesOnGetCategories, fn: onGetCategories },
        { endpoint: EndpointsEnum.TokenOnUpdateSettings, fn: onUpdateTokenSettings },
    ];

    const renderActionsFn = (row: ICatalog_ItemUI, rowIndex: number, isDetailViewTable?: boolean, parentRowIndex?: number) => {
        if (!canEditAccess || row.has_alternate_sourcing || supplierModel.inventory_screen_read_only || selectedVendor) {
            return null;
        }

        let _row = row;

        if (isDetailViewTable) {
            // @ts-expect-error
            _row = row.Source_Catalog_Item;
        }

        return (
            <div className={"w-15r"}>
                <div className={"d-flex align-items-center"}>
                    <div>
                        <OwInventoryAdjustment
                            catalogItem={_row}
                            saveFn={saveAdjustment}
                            isDetailViewTable={isDetailViewTable}
                            parentRowIndex={parentRowIndex}
                            warehouses={warehouses}
                            notifyFn={uiContext.notifyFn}
                        />
                    </div>

                    <div className={"ms-2"}>
                        <Dropdown>
                            <Dropdown.Toggle size="sm" variant="secondary" id={`actions-dropdown-${_row.guid}`}>
                                <OwTranslate id="actions" defaultMessage="Actions" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className={UIService.isMainViewLight() ? "" : "bg-secondary"}>
                                <Dropdown.Item onClick={() => releaseHeldInventory(_row)}>
                                    <OwTranslate id="release_held_inventory" defaultMessage="Release Held Inventory" />
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            </div>
        );
    };

    const releaseHeldInventory = async (catalogItem: ICatalog_ItemUI) => {
        // TODO: Implement release held inventory functionality
        console.log("Release held inventory for item:", catalogItem);

        const url = buildRestUrl({
            endpoint: RestEndpointsEnum.InventoryReleaseHeld,
            params: {
                catalogItemGuid: catalogItem.guid,
            },
        });

        const headers = buildAuthHeadersForFetch({
            userModel,
            supplierModel,
        });

        // const qtyToRelease = 0; // TODO: Implement qty to release
        const reason = "Release held inventory";

        const body = JSON.stringify({
            reason,
        });

        const res = await fetch(url, {
            method: "POST",
            headers,
            body,
        });

        if (res.ok) {
            const notification: INotification = {
                message: "successfully_released_held_inventory",
                level: NotificationLevelEnum.success,
                position: NotificationPositionEnum.bc,
            };

            uiContext.notifyFn(null, notification);

            getStockLevels("releaseHeldInventory");
        }
    };

    const renderTotalQtyOnHand = (row: ICatalog_Item, rowIndex: number, isDetailViewRow?: boolean, parentRowIndex?: number) => {
        const total_qty_on_hand =
            Number(row.qty_on_hand || 0) + Number(row.reserved_qty_on_hand || 0) + Number(row.qty_held_for_backorders || 0);

        // let _row = row;

        // if (isDetailViewRow) {
        //     // @ts-expect-error
        //     _row = row.Source_Catalog_Item;
        // }

        return <div>{total_qty_on_hand}</div>;
    };

    // Van warehouses are provisioned is_hidden, so they only surface in the
    // per-warehouse breakdowns when the Include Vehicles toggle is on.
    const isVisibleWarehouseMap = (mapDetail: IWarehouse_Catalog_Items_Map) =>
        !mapDetail.Warehouse?.is_hidden || (includeVehicles && !!mapDetail.Warehouse?.is_vehicle);

    const renderWarehouseName = (mapDetail: IWarehouse_Catalog_Items_Map) => (
        <>
            {mapDetail.Warehouse?.is_vehicle ? <i className={"fad fa-truck me-1"} /> : null}
            {mapDetail.Warehouse?.name}
        </>
    );

    const renderQtyOnHand = (row: ICatalog_Item, rowIndex: number, isDetailViewRow?: boolean, parentRowIndex?: number) => {
        let qty_on_hand: any = 0;

        let _row = row;

        if (isDetailViewRow) {
            // @ts-expect-error
            _row = row.Source_Catalog_Item;
        }

        const showInventoryDetails = UserService.showInventoryDetails(supplierModel, userModel);

        // console.log("renderQtyOnHand", row, rowIndex, isDetailViewRow, parentRowIndex);

        if (!_row.allow_backorder) {
            if (_row.qty_on_hand) {
                if (!showInventoryDetails) {
                    qty_on_hand = `Y`;
                } else {
                    qty_on_hand = <QtyOnHandValue catalogItem={_row} showColoredQoh={true} />;
                }
            } else {
                if (!showInventoryDetails) {
                    qty_on_hand = `N`;
                } else {
                    qty_on_hand = 0;
                }
            }
        } else {
            if (_row.qty_on_hand) {
                if (_row.qty_on_hand > 0) {
                    if (!showInventoryDetails) {
                        qty_on_hand = "Y";
                    } else {
                        qty_on_hand = <QtyOnHandValue catalogItem={_row} showColoredQoh={true} />;
                    }
                } else {
                    if (!showInventoryDetails) {
                        qty_on_hand = "BO";
                    } else {
                        qty_on_hand = (
                            <span>
                                <OwLabel title={"backordered"} noBottomMargin={true} />
                                {` (`}
                                <QtyOnHandValue catalogItem={_row} showColoredQoh={true} />
                                {`)`}
                            </span>
                        );
                    }
                }
            } else {
                if (!showInventoryDetails) {
                    qty_on_hand = "N";
                }
            }
        }

        let warehouseDetail: any = null;

        if (supplierModel.has_warehouses) {
            qty_on_hand = 0;

            if (row.Warehouse_Catalog_Items_Maps) {
                warehouseDetail = row.Warehouse_Catalog_Items_Maps.filter(isVisibleWarehouseMap)
                    // .filter((mapDetail) => mapDetail.qty_on_hand)
                    .map((mapDetail) => {
                        qty_on_hand += mapDetail.qty_on_hand;

                        return (
                            <tr key={mapDetail.guid}>
                                <th>{renderWarehouseName(mapDetail)}</th>
                                <td>
                                    <QtyOnHandValue catalogItem={_row} mapItem={mapDetail} showColoredQoh={true} />
                                </td>
                            </tr>
                        );
                    });
            } else {
                warehouseDetail = <div>No warehouse inventory found</div>;
            }

            let tableClass = "table mt-2";

            if (!UIService.isMainViewLight()) {
                tableClass += " table-dark";
            }

            warehouseDetail = <table className={tableClass}>{warehouseDetail}</table>;
        }

        return (
            <div className={"d-flex flex-column justify-content-end"}>
                <div>{showInventoryDetails ? <QtyOnHandValue catalogItem={_row} showColoredQoh={true} /> : qty_on_hand}</div>
                <div>{warehouseDetail}</div>
            </div>
        );
    };

    const renderLastUpdated = (updatedAt: string) => {
        return parseLastUpdated(updatedAt);
    };

    const detailViewColumns = [
        {
            title: "",
            valueProp: "",
            isActionsCol: true,
            renderFn: renderActionsFn,
            renderFnEmitsRow: true,
            className: "w-9r",
        },
        {
            title: "name",
            valueProp: "Source_Catalog_Item",
            valueSubProp: "name",
        },
        {
            title: "sku",
            valueProp: "Source_Catalog_Item",
            valueSubProp: "sku",
        },
        {
            title: "description",
            valueProp: "Source_Catalog_Item",
            valueSubProp: "description",
            className: "pre-wrap",
        },
        {
            title: "total_qty_on_hand",
            valueProp: "Source_Catalog_Item",
            valueSubProp: "total_qty_on_hand",
            renderFn: renderTotalQtyOnHand,
            renderFnEmitsRow: true,
            className: "text-center",
        },
        {
            title: "qty_on_hand",
            valueProp: "Source_Catalog_Item",
            valueSubProp: "qty_on_hand",
            renderFn: renderQtyOnHand,
            renderFnEmitsRow: true,
            className: "text-center",
        },
        {
            title: "reserved_qty_on_hand",
            valueProp: "Source_Catalog_Item",
            valueSubProp: "reserved_qty_on_hand",
        },
        {
            title: "last_updated",
            valueProp: "Source_Catalog_Item",
            valueSubProp: "updated_at",
            renderFn: renderLastUpdated,
        },
    ];

    const getEditAccess = () => {
        let editAccess = false;

        if (userModel?.isSupplierUser) {
            // @ts-expect-error
            editAccess = ViewAccessService.Inventory[userModel.userType!.name].EDIT;
        }

        return editAccess;
    };

    const getOutOfStockOnly = () => {
        let onlyOutOfStock = false;

        if (!_.isString(supplierModel.settings) && !_.isNil(supplierModel.settings.screens?.inventory?.out_of_stock_only)) {
            onlyOutOfStock = supplierModel.settings.screens!.inventory!.out_of_stock_only;
        }

        return onlyOutOfStock;
    };

    const [canEditAccess, setCanEditAccess] = useState(!isReadOnly);
    const [catalogs, setCatalogs] = useState<ICatalog[]>([]);
    const [catalogItems, setCatalogItems] = useState<ICatalog_ItemUI[]>([]);
    const [outOfStockOnly, setOutOfStockOnly] = useState(getOutOfStockOnly());
    const [name, setName] = useState<string>("");
    const [manufacturer, setManufacturer] = useState<string>("");
    const [stock, setStock] = useState<"in_stock_only" | "out_of_stock_only" | "all">(outOfStockOnly ? "out_of_stock_only" : "all");
    const [stockLevelsBtnActive, setStockLevelsBtnActive] = useState(false);
    const navItems: IBreadcrumbs[] = [
        { title: "Dashboard", url: "/dashboard" },
        { title: "Inventory", url: "/inventory" },
    ];
    const [limit, setLimit] = useState(25);
    const [offset, setOffset] = useState(0);
    const [totalCatalogItems, setTotalCatalogItems] = useState(0);
    const [columns, setColumns] = useState<IOwTableCols[]>([]);
    const [isDataFetching, setIsDataFetching] = useState(true);
    const [isInitialData, setIsInitialData] = useState(true);
    const [catalogGuid, setCatalogGuid] = useState<string | undefined>();
    const [priceGroupGuid, setPriceGroupGuid] = useState<string>("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalComponent, setModalComponent] = useState<any>(null);
    const [modalStyle, setModalStyle] = useState<any>({
        content: {
            top: "10px",
            left: "10px",
            right: "10px",
            bottom: "10px",
        },
        overlay: {
            zIndex: 100,
        },
    });
    const [activeInventoryCsvBtn, setActiveInventoryCsvBtn] = useState(false);
    const currentToken = UserService.getCurrentToken(userModel);
    const [tableConfig, setTableConfig] = useState<IOwTableConfig>({
        tableHover: true,
        stickyHeader: currentToken?.settings?.inventory_fixed_header || false,
        stickyHeaderMaxHeight: "calc(100vh - 250px)",
    });
    const [detailViewData, setDetailViewData] = useState<any>(null);
    const [cartItems, setCartItems] = useState<ICatalog_ItemUI[]>([]);

    const [selectedVendor, setSelectedVendor] = useState<IVendorModel | null>(userModel.isSupplierUser ? null : vendorModel);
    const [priceGroups, setPriceGroups] = useState<IPrice_Group[]>([]);
    const [createOrderActive, setCreateOrderActive] = useState(false);
    const [priceGroup, setPriceGroup] = useState<IPrice_Group | null>(null);
    const [catalog, setCatalog] = useState<ICatalog | null>(null);

    const [warehouses, setWarehouses] = useState<IWarehouse[]>([]);
    const [scanMode, setScanMode] = useState(!!supplierModel.pick_list_scan_mode_active);
    // Add this near your other state declarations
    const capturedValueRef = useRef("");
    const [capturedScanValue, setCapturedScanValue] = useState("");
    const [sortOrder, setSortOrder] = useState<SortOrderEnum>(SortOrderEnum.ASC);
    const [sortCol, setSortCol] = useState<string>("name");
    const [categories, setCategories] = useState<ICategory[]>([]);
    const [selectedCategory, setSelectedCategory] = useState<ICategory>();
    const [mobileViewComponent, setMobileViewComponent] = useState<any>(null);
    const [showMobileItemView, setShowMobileItemView] = useState(false);
    const [currencyConversion, setCurrencyConversion] = useState(!!supplierModel.has_currencies);
    const [includeVehicles, setIncludeVehicles] = useState(false);
    const [isReset, setIsReset] = useState(false);
    const [doScanSearch, setDoScanSearch] = useState(false);
    const [hasPaginationChange, setHasPaginationChange] = useState(false);
    const [inventoryViewMode, setInventoryViewMode] = useState<"standard" | "by_customer">("standard");

    const canViewByCustomer = useMemo(
        () =>
            userModel.isSupplierUser &&
            (userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.ADMIN ||
                userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.INVENTORY_MGMT),
        [userModel]
    );

    useEffect(() => {
        if (!canViewByCustomer && inventoryViewMode !== "standard") {
            setInventoryViewMode("standard");
        }
    }, [canViewByCustomer, inventoryViewMode]);

    useEffect(() => {
        if (catalog) {
            setViewColumns(getColumns(catalog));
        }
    }, [catalog]);

    useEffect(() => {
        setupTableColumns();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [viewColumns, priceGroup]);

    const setupSockets = () => {
        for (const _socket of sockets) {
            socket.off(_socket.endpoint, _socket.fn);
        }

        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }
    };

    // First, create a separate useEffect for socket handlers that need access to current state
    useEffect(() => {
        // Define handlers inside useEffect to access fresh values
        const onAdjustWarehouseInventory = (data: IOnAdjustWarehouseInventoryDTO) => {
            const notification: INotification = {
                message: "successfully_updated_catalog_inventory",
                level: NotificationLevelEnum.success,
                position: NotificationPositionEnum.bc,
            };

            uiContext.notifyFn(null, notification);

            getStockLevels("onAdjustWarehouseInventory");
        };

        const onPerformCatalogCSVInventoryUpdate = (data: IOnPerformCatalogCSVInventoryUpdateDTO) => {
            const notification: INotification = {
                message: "successfully_updated_catalog_inventory",
                level: NotificationLevelEnum.success,
                position: NotificationPositionEnum.bc,
            };

            uiContext.notifyFn(null, notification);

            // Now this will use current values of state variables
            getStockLevels("onPerformCatalogCSVInventoryUpdate");
        };

        // Setup socket listeners
        socket.on(EndpointsEnum.CatalogsOnPerformCatalogCSVInventoryUpdate, onPerformCatalogCSVInventoryUpdate);
        socket.on(EndpointsEnum.WarehouseOnAdjustWarehouseInventory, onAdjustWarehouseInventory);
        // socket.on(EndpointsEnum.CatalogsOnGetStockLevels, onGetStockLevels);

        // Cleanup function
        return () => {
            socket.off(EndpointsEnum.CatalogsOnPerformCatalogCSVInventoryUpdate, onPerformCatalogCSVInventoryUpdate);
            socket.off(EndpointsEnum.WarehouseOnAdjustWarehouseInventory, onAdjustWarehouseInventory);
            // socket.off(EndpointsEnum.CatalogsOnGetStockLevels, onGetStockLevels);
        };
    }, [
        // Add dependencies for values used in the handlers
        name,
        // Include any other state variables or props used in these handlers
    ]);

    useEffect(() => {
        window.document.title = "Orderwerks >> Inventory";

        setupSockets();

        if (userModel.isSupplierUser) {
            getSupplierTokens();
        }

        if (supplierModel.has_warehouses) {
            getWarehouses();
        }

        getCatalogs();

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    useEffect(() => {
        getStockLevels("sortCol, sortOrder useEffect");
    }, [sortCol, sortOrder]);

    useEffect(() => {
        if (catalogGuid) {
            setupTableColumns();
            getStockLevels("catalogs,catalogGuid useEffect");
            getCategories();

            const { priceGroupDetail, priceGroups } = getPriceGroupFromCatalogGuid(true);

            if (priceGroupDetail) {
                setPriceGroupGuid(priceGroupDetail.guid);
                setPriceGroup(priceGroupDetail);
            }

            setPriceGroups(priceGroups);

            setupSockets();
        }
    }, [catalogGuid]);

    useEffect(() => {
        if (isReset) {
            getStockLevels("isReset");
            setIsReset(false);
        }
    }, [isReset]);

    useEffect(() => {
        setupTableColumns();
    }, [selectedVendor]);

    // Columns live in state, so the renderFn closures capture includeVehicles at
    // setup time — rebuild them whenever the toggle flips or it appears dead.
    useEffect(() => {
        setupTableColumns();
    }, [includeVehicles]);

    useEffect(() => {
        if (doScanSearch) {
            enterSearch({ key: "Enter" });
        }
    }, [doScanSearch]);

    // Move keyboardListener inside useEffect so it gets fresh scanMode value
    useEffect(() => {
        const keyboardListener = (e: KeyboardEvent) => {
            if (!scanMode) return;

            // Ignore modifier keys
            switch (e.key) {
                case "Shift":
                case "Control":
                case "Alt":
                case "Meta":
                case "Unidentified":
                    return;

                case "Enter":
                    // Process the complete scan
                    processCapturedScanValue(capturedValueRef.current);
                    // Reset both the ref and state
                    capturedValueRef.current = "";
                    setCapturedScanValue("");
                    return;
            }

            // Update both ref and state
            const newValue = capturedValueRef.current + e.key;
            capturedValueRef.current = newValue;
            setCapturedScanValue(newValue);
        };

        const processCapturedScanValue = (value: string) => {
            if (value.length) {
                const notification: INotification = {
                    message: "scan_captured",
                    level: NotificationLevelEnum.success,
                    position: NotificationPositionEnum.bc,
                };

                uiContext.notifyFn(null, notification);

                setName(value);
                setShowMobileItemView(true);
                setDoScanSearch(true);
            } else {
                const notification: INotification = {
                    message: "error_capturing_scan",
                    level: NotificationLevelEnum.error,
                    position: NotificationPositionEnum.bc,
                };

                uiContext.notifyFn(null, notification);
            }
        };

        document.addEventListener("keydown", keyboardListener);

        return () => {
            document.removeEventListener("keydown", keyboardListener);
            // Clean up ref on unmount
            capturedValueRef.current = "";
        };
    }, [scanMode]); // scanMode dependency will recreate the listener when it changes

    const toggleCurrencyConversion = () => {
        setCurrencyConversion(!currencyConversion);
    };

    const toggleScanMode = () => {
        setScanMode(!scanMode);
    };

    const toggleIncludeVehicles = () => {
        setIncludeVehicles(!includeVehicles);
    };

    const openItem = () => {};

    const setupTableColumns = () => {
        const currentCatalogGuid = catalogGuid;

        const catalogModel = catalogs.find((_catalog) => {
            return _catalog.guid === currentCatalogGuid;
        });

        if (catalogModel) {
            const inventory_row_config = ensureInProductionInRowConfig(catalogModel.inventory_row_config || getDefaultInventoryRowConfig());

            let _columns: IOwTableCols[] = [];

            if (inventory_row_config) {
                const isSupplierUser = userModel?.isSupplierUser;
                for (const col of inventory_row_config) {
                    // Skip the Column if it's only for supplier users.
                    if (col.isSupplier && !isSupplierUser) {
                        continue;
                    }

                    switch (col.property) {
                        case InventoryRowColPropertyEnum.ACTIONS:
                            if (isSupplierUser) {
                                _columns.push(getActionCol());
                            }
                            break;

                        case InventoryRowColPropertyEnum.NAME:
                            _columns.push(getNameCol());
                            break;

                        case InventoryRowColPropertyEnum.DESCRIPTION:
                            _columns.push(getDescriptionCol(col));
                            break;

                        case InventoryRowColPropertyEnum.SKU:
                            _columns.push(getSkuCol());
                            break;

                        case InventoryRowColPropertyEnum.UOM:
                            _columns.push(getUomCol());
                            break;

                        case InventoryRowColPropertyEnum.MSRP:
                            _columns.push(getMsrpCol());
                            break;

                        case InventoryRowColPropertyEnum.MAP:
                            _columns.push(getMapCol(col));
                            break;

                        case InventoryRowColPropertyEnum.PRICE_GROUP:
                            _columns.push(getPriceGroupCol(col));
                            break;

                        case InventoryRowColPropertyEnum.TOTAL_QTY_ON_HAND:
                            _columns.push(getTotalQtyOnHandCol());
                            break;

                        case InventoryRowColPropertyEnum.QTY_ON_HAND:
                            _columns.push(getQtyOnHandCol());
                            break;

                        case InventoryRowColPropertyEnum.QTY_IN_PRODUCTION:
                            if (supplierModel.has_serials && supplierModel.has_serial_production) {
                                _columns.push(getInProductionQtyCol());
                            }
                            break;

                        case InventoryRowColPropertyEnum.LOCATION:
                            _columns.push(getLocationCol());
                            break;

                        case InventoryRowColPropertyEnum.PURCHASE_LINK:
                            _columns.push(getPurchaseLinkCol());
                            break;

                        case InventoryRowColPropertyEnum.RESERVED_QTY_ON_HAND:
                            if (userModel.isSupplierUser) {
                                if (userModel.supplierUserToken?.is_sales_rep && supplierModel.hide_inventory_from_sales_reps) {
                                    break;
                                    // do nothing
                                } else {
                                    _columns.push(getReservedQtyOnHandCol());
                                }
                            }
                            break;

                        case InventoryRowColPropertyEnum.LAST_UPDATED:
                            _columns.push(getLastUpdatedCol());
                            break;

                        case InventoryRowColPropertyEnum.PACK:
                            _columns.push(getPackCol());
                            break;

                        case InventoryRowColPropertyEnum.QTY_INCOMING:
                            _columns.push(getIncomingQtyCol());
                            break;

                        case InventoryRowColPropertyEnum.QTY_BACKORDERED:
                            _columns.push(getBackorderedQtyCol());
                            break;

                        case InventoryRowColPropertyEnum.BACKORDER_LIMIT:
                            _columns.push(getBackorderLimitCol());
                            break;

                        case InventoryRowColPropertyEnum.QTY_HELD_FOR_BACKORDERS:
                            _columns.push(getQtyHeldForBackordersCol());
                            break;
                    }
                }
            } else {
                _columns = defaultTableColumns();
            }

            if (supplierModel.allow_inventory_screen_order) {
                _columns.splice(1, 0, getOrderCol());
            }

            setColumns(_columns);
        }
    };

    const toggleSortDir = (_sortCol: string, _sortOrder: SortOrderEnum) => {
        setSortCol(_sortCol);
        setSortOrder(_sortOrder);
    };

    const getActionCol = (): IOwTableCols => {
        return {
            title: "",
            valueProp: "",
            isActionsCol: true,
            renderFn: renderActionsFn,
            renderFnEmitsRow: true,
            className: selectedVendor ? "w-9r" : "",
        };
    };

    const getOrderCol = (): IOwTableCols => {
        return {
            title: "",
            valueProp: "",
            isActionsCol: true,
            renderFn: renderCartEntryFn,
            renderFnEmitsRow: true,
            // isChecked: () => {
            //     return viewColumns.order.isChecked;
            // }
        };
    };

    const getPackCol = (): IOwTableCols => {
        return {
            title: "packs",
            valueProp: "packs",
            renderFn: renderPackQty,
            className: "text-center",
            isChecked: () => {
                return viewColumns.pack?.isChecked ?? false;
            },
        };
    };

    const getIncomingQtyCol = (): IOwTableCols => {
        return {
            title: "incoming",
            valueProp: "qty_incoming",
            renderFn: renderQtyIncoming,
            renderFnEmitsRow: true,
            className: "text-center",
            isChecked: () => {
                return viewColumns.qty_incoming?.isChecked ?? false;
            },
        };
    };

    const getQtyHeldForBackordersCol = (): IOwTableCols => {
        return {
            title: "qty_held_for_backorders",
            valueProp: "qty_held_for_backorders",
            renderFn: renderQtyHeldForBackorders,
            renderFnEmitsRow: true,
            className: "text-center",
            isChecked: () => {
                return viewColumns.qty_held_for_backorders?.isChecked ?? false;
            },
        };
    };

    const getBackorderedQtyCol = (): IOwTableCols => {
        return {
            title: "backordered",
            valueProp: "qty_backordered",
            renderFn: renderQtyBackordered,
            renderFnEmitsRow: true,
            className: "text-center",
            isChecked: () => {
                return viewColumns.qty_backordered?.isChecked ?? false;
            },
        };
    };

    const getBackorderLimitCol = (): IOwTableCols => {
        return {
            title: "backorder_limit",
            valueProp: "backorder_limit",
            renderFn: renderBackorderLimit,
            renderFnEmitsRow: true,
            className: "text-center",
            isChecked: () => {
                return viewColumns.backorder_limit?.isChecked ?? false;
            },
        };
    };

    const getNameCol = (): IOwTableCols => {
        return {
            title: "name",
            valueProp: "name",
            renderFn: renderNameCol,
            renderFnEmitsRow: true,
            isSortable: true,
            sortOrderFn: () => {
                return sortOrder;
            },
            sortFn: (_sortCol: string, _sortOrder: SortOrderEnum) => {
                toggleSortDir("name", _sortOrder);
            },
            isChecked: () => {
                return viewColumns.name?.isChecked ?? false;
            },
        };
    };

    const renderNameCol = (row: ICatalog_ItemUI) => {
        return (
            <div className={""} style={{ whiteSpace: "nowrap" }}>
                <div>{row.name}</div>
                <div>
                    <OwS3ImageViewer
                        catalogItem={row}
                        isMicroView={true}
                        attachmentIndex={0}
                        imageIndex={IImageSizeEnum.THUMB}
                        className={"me-2 mb-2 mb-md-0"}
                        includeAllImages={true}
                        hideEmptyImage={true}
                    />
                </div>
            </div>
        );
    };

    const getSkuCol = (): IOwTableCols => {
        return {
            title: "sku",
            valueProp: "sku",
            isSortable: true,
            renderFn: renderSkuCol,
            renderFnEmitsRow: true,
            sortOrderFn: () => {
                return sortOrder;
            },
            sortFn: (_sortCol: string, _sortOrder: SortOrderEnum) => {
                toggleSortDir("sku", _sortOrder);
            },
            isChecked: () => {
                return viewColumns.sku?.isChecked ?? false;
            },
        };
    };

    const getDescriptionCol = (col?: IInventoryRowConfig): IOwTableCols => {
        return {
            title: "description",
            valueProp: "description",
            titleRenderFn: (_col) => renderDescriptionColTitleFn(col),
            renderFn: renderDescriptionCol,
            renderFnEmitsRow: true,
            isChecked: () => {
                return viewColumns.description?.isChecked ?? false;
            },
        };
    };

    const getMsrpCol = (): IOwTableCols => {
        return {
            className: "text-end",
            title: "MSRP",
            valueProp: "",
            renderFn: renderMsrp,
            renderFnEmitsRow: true,
            skipTitleTranslate: true,
            isChecked: () => {
                return viewColumns.msrp?.isChecked ?? false;
            },
        };
    };

    const getPriceGroupFromPriceGroupId = (priceGroupId: number, returnPriceGroup?: boolean) => {
        let priceGroupName = "";
        let priceGroupDetail: IPrice_Group | undefined;

        if (catalogGuid) {
            const catalogModel = catalogs.find((_catalog) => {
                return _catalog.guid === catalogGuid;
            });

            if (catalogModel) {
                const _priceGroups = catalogModel.Price_Groups;

                if (_priceGroups) {
                    if (_priceGroups.length === 1) {
                        priceGroupName = _priceGroups[0].value;
                        priceGroupDetail = _priceGroups[0];
                    } else {
                        let index = 0;
                        for (const _priceGroup of priceGroups) {
                            if (_priceGroup.id === Number(priceGroupId)) {
                                priceGroupName = priceGroups[index].value;
                                priceGroupDetail = _priceGroup;
                            }
                            index++;
                        }
                    }
                }
            }
        }

        if (returnPriceGroup) {
            return priceGroupDetail;
        } else {
            return priceGroupName;
        }
    };

    const getPriceGroupFromCatalogGuid = (
        returnPriceGroup?: boolean,
        col?: IInventoryRowConfig
    ): { priceGroupName: string; priceGroupDetail: IPrice_Group | undefined; priceGroups: IPrice_Group[] } => {
        let priceGroupName = "";
        let priceGroupDetail: IPrice_Group | undefined;
        let _priceGroups: IPrice_Group[] = [];

        if (catalogGuid) {
            const catalogModel = catalogs.find((_catalog) => {
                return _catalog.guid === catalogGuid;
            });

            if (catalogModel) {
                if (userModel?.isSupplierUser || _.isNil(vendorModel?.price_group_id)) {
                    _priceGroups = catalogModel.Price_Groups || [];

                    if (_priceGroups) {
                        if (_priceGroups.length === 1) {
                            priceGroupName = _priceGroups[0].value;
                            priceGroupDetail = _priceGroups[0];
                        } else {
                            let index = 0;
                            for (const _priceGroup of _priceGroups) {
                                if (_priceGroup.id === vendorModel?.price_group_id) {
                                    priceGroupName = _priceGroups[index].value;
                                    priceGroupDetail = _priceGroup;
                                }
                                index++;
                            }
                        }
                    }

                    if (selectedVendor) {
                        if (selectedVendor.price_group_id) {
                            if (_priceGroups) {
                                let index = 0;
                                for (const _priceGroup of _priceGroups) {
                                    if (_priceGroup.id === selectedVendor.price_group_id) {
                                        priceGroupName = _priceGroups[index].value;
                                        priceGroupDetail = _priceGroup;
                                    }
                                    index++;
                                }
                            }

                            // Fallback to use selectedVendor.Price_Group directly if not found in catalog's Price_Groups array
                            if (!priceGroupDetail && selectedVendor.Price_Group) {
                                priceGroupName = selectedVendor.Price_Group.value;
                                priceGroupDetail = selectedVendor.Price_Group;
                            }
                        }
                    }
                } else {
                    if (vendorModel.price_group_id) {
                        const _priceGroups = catalogModel.Price_Groups;

                        if (_priceGroups) {
                            let index = 0;
                            for (const _priceGroup of _priceGroups) {
                                if (_priceGroup.id === vendorModel.price_group_id) {
                                    priceGroupName = _priceGroups[index].value;
                                    priceGroupDetail = _priceGroup;
                                }
                                index++;
                            }
                        } else {
                            if (vendorModel.Price_Group) {
                                priceGroupName = vendorModel.Price_Group.value;
                                priceGroupDetail = vendorModel.Price_Group;
                            }
                        }
                    }
                }
            }
        }

        if (returnPriceGroup && priceGroupDetail) {
            if (col?.titleOverride) {
                priceGroupDetail.value = col.titleOverride;
            }

            priceGroupDetail.value = _.startCase(priceGroupDetail.value);

            return { priceGroupName, priceGroupDetail, priceGroups: _priceGroups };
        } else {
            if (col?.titleOverride) {
                return { priceGroupName: col.titleOverride, priceGroups: _priceGroups, priceGroupDetail: undefined };
            } else {
                return { priceGroupName: _.startCase(priceGroupName), priceGroups: _priceGroups, priceGroupDetail: undefined };
            }
        }
    };

    const getPriceGroupCol = (col: IInventoryRowConfig): IOwTableCols => {
        const { priceGroupName } = getPriceGroupFromCatalogGuid(false, col);

        return {
            className: "text-end",
            title: priceGroupName,
            valueProp: "",
            renderFn: renderPriceGroup,
            renderFnEmitsRow: true,
            skipTitleTranslate: true,
            isChecked: () => {
                return viewColumns.price_group?.isChecked ?? false;
            },
        };
    };

    const getMapCol = (col: IInventoryRowConfig): IOwTableCols => {
        return {
            className: "text-end",
            title: "MAP",
            valueProp: "",
            renderFn: renderMap,
            renderFnEmitsRow: true,
            skipTitleTranslate: true,
            isChecked: () => {
                return viewColumns.map?.isChecked ?? false;
            },
        };
    };

    const getUomCol = (): IOwTableCols => {
        return {
            title: "uom",
            valueProp: "Unit_Of_Measurement",
            valueSubProp: "name",
            isChecked: () => {
                return viewColumns.uom?.isChecked ?? false;
            },
        };
    };

    const getPurchaseLinkCol = (): IOwTableCols => {
        return {
            title: "purchase_link",
            valueProp: "purchase_link",
            renderFn: renderPurchaseLink,
            renderFnEmitsRow: true,
            className: "text-end",
            isChecked: () => {
                return viewColumns.purchase_link?.isChecked ?? false;
            },
        };
    };

    const getLocationCol = (): IOwTableCols => {
        return {
            title: "location",
            valueProp: "location",
            renderFn: renderLocation,
            renderFnEmitsRow: true,
            className: "text-end",
            isChecked: () => {
                return viewColumns.location?.isChecked ?? false;
            },
        };
    };

    const getTotalQtyOnHandCol = (): IOwTableCols => {
        return {
            title: "total_on_hand",
            valueProp: "total_qty_on_hand",
            renderFn: renderTotalQtyOnHand,
            renderFnEmitsRow: true,
            className: "text-center",
            isChecked: () => {
                return viewColumns.total_qty_on_hand?.isChecked ?? false;
            },
        };
    };

    const getQtyOnHandCol = (): IOwTableCols => {
        return {
            title: "available",
            valueProp: "qty_on_hand",
            renderFn: renderQtyOnHand,
            renderFnEmitsRow: true,
            isSortable: true,
            sortOrderFn: () => {
                return sortOrder;
            },
            sortFn: (_sortCol: string, _sortOrder: SortOrderEnum) => {
                toggleSortDir("qty_on_hand", _sortOrder);
            },
            className: "text-end",
            isChecked: () => {
                return viewColumns.qty_on_hand?.isChecked ?? false;
            },
        };
    };

    const getInProductionQtyCol = (): IOwTableCols => {
        return {
            title: "in_production",
            valueProp: "qty_in_production",
            renderFn: renderQtyInProduction,
            renderFnEmitsRow: true,
            className: "text-end",
            isChecked: () => {
                return viewColumns.qty_in_production?.isChecked ?? false;
            },
        };
    };

    const getReservedQtyOnHandCol = (): IOwTableCols => {
        return {
            title: "reserved",
            valueProp: "reserved_qty_on_hand",
            renderFn: renderReservedQtyOnHand,
            renderFnEmitsRow: true,
            className: "text-end",
            isChecked: () => {
                return viewColumns.reserved_qty_on_hand?.isChecked ?? false;
            },
        };
    };

    const getLastUpdatedCol = (): IOwTableCols => {
        return {
            title: "last_updated",
            valueProp: "updated_at",
            renderFn: renderLastUpdated,
            isChecked: () => {
                return viewColumns.last_updated?.isChecked ?? false;
            },
        };
    };

    const defaultTableColumns = (): IOwTableCols[] => {
        const _columns: IOwTableCols[] = [getActionCol(), getNameCol(), getSkuCol(), getDescriptionCol()];

        if (supplierModel.has_pricing_on_inventory) {
            // get the first price group?
            _columns.push(getMsrpCol());

            _columns.push(getUomCol());

            _columns.push(getQtyOnHandCol());

            if (userModel?.isSupplierUser) {
                if (!userModel.supplierUserToken?.is_sales_rep) {
                    _columns.push(getReservedQtyOnHandCol());
                }
            }

            _columns.push(getLastUpdatedCol());
        } else {
            _columns.push(getUomCol());

            _columns.push(getQtyOnHandCol());

            if (userModel?.isSupplierUser) {
                if (!userModel.supplierUserToken?.is_sales_rep) {
                    _columns.push(getReservedQtyOnHandCol());
                }

                _columns.push(getIncomingQtyCol());

                _columns.push(getBackorderedQtyCol());

                _columns.push(getBackorderLimitCol());

                _columns.push(getQtyHeldForBackordersCol());
            }

            _columns.push(getLastUpdatedCol());
        }

        return _columns;
    };

    const viewCart = () => {
        showSidebar();
    };

    const updateCartItems = (_cartItems: ICatalog_ItemUI[]) => {
        setCartItems(_cartItems);
    };

    const addItemToCart = (item: ICatalog_ItemUI) => {
        setCartItems((prevCartItems) => {
            const _cartItems = [...prevCartItems];
            let existingItem: ICatalog_ItemUI | null = null;

            for (const cartItem of _cartItems) {
                if (cartItem.guid === item.guid) {
                    existingItem = cartItem;
                    if (cartItem && item) {
                        cartItem.qty! = item.qty || 0;
                    }
                }
            }

            if (!existingItem) {
                item.addedItem = true;
                _cartItems.push(item);
            }

            return _cartItems;
        });
    };

    const handleCartEntry = (e: ChangeEvent<any>, item: ICatalog_ItemUI) => {
        const _cartItems = [...cartItems];
        const _catalogItems = [...catalogItems];

        const existingItem = false;

        const enteredQty = Number(e.target.value || 0);

        const mockOrder = {} as IOrder;

        const validDetail = OrderEntryService.doInventoryValidation(item, enteredQty, [], supplierModel, mockOrder, 0);

        for (const catalogItem of _catalogItems) {
            if (catalogItem.guid === item.guid) {
                if (validDetail.enableAdd) {
                    catalogItem.qty = validDetail.qty;
                }
            }
        }

        setCatalogItems(_catalogItems);
    };

    const addItemEnter = (e: KeyboardEvent, row: ICatalog_ItemUI) => {
        if (e.key === "Enter" && row.qty && row.qty > 0) {
            addItemToCart(row);
        }
    };

    const renderDescriptionColTitleFn = (col?: IInventoryRowConfig) => {
        if (col?.titleOverride) {
            return col.titleOverride;
        } else {
            return <OwLabel title={"description"} />;
        }
    };

    const renderCartEntryFn = (row: ICatalog_ItemUI, rowIndex: number, isDetailViewTable?: boolean, parentRowIndex?: number) => {
        // console.log("renderCartEntryFn: ", selectedVendor);
        if (!selectedVendor) {
            return null;
        }

        return <InventoryItemAddDetail row={row} addItemToCart={addItemToCart} supplierModel={supplierModel} />;
    };

    const saveAdjustment = (options: {
        catalogItem: ICatalog_Item;
        qtyAdjustment: number;
        adjustmentType: InventoryActionEnum;
        isDetailViewTable?: boolean;
        parentRowIndex?: number;
        selectedWarehouseGuid?: string;
        note?: string;
    }) => {
        if (supplierModel.has_warehouses) {
            const payload: IAdjustWarehouseInventoryDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                qty: options.qtyAdjustment,
                operation: options.adjustmentType,
                catalogItemGuid: options.catalogItem.guid,
                warehouseGuid: options.selectedWarehouseGuid!,
                note: options.note,
            };

            socket.emit(EndpointsEnum.WarehouseAdjustWarehouseInventory, payload);
        } else {
            const row: ICatalogCSVInventoryDataRow = {
                sku: options.catalogItem.sku || "",
                description: "",
                item_guid: options.catalogItem.guid,
                qty_on_hand: options.qtyAdjustment,
                track_inventory: 1,
                min_qty_on_hand: options.catalogItem.min_qty_on_hand!,
                max_qty_on_hand: options.catalogItem.max_qty_on_hand!,
                packs: options.catalogItem.packs || 0,
            };

            const rows = [row];

            const payload: IPerformCatalogCSVInventoryUpdateDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                action: options.adjustmentType,
                rows: JSON.stringify(rows),
                note: options.note,
                referenceColumn: InventoryUpdateReferenceColEnum.ITEM_GUID,
            };

            socket.emit(EndpointsEnum.CatalogsPerformCatalogCSVInventoryUpdate, payload);
        }
    };

    const getCategories = () => {
        const payload: IGetCategoriesDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            vendorGuid: vendorModel.guid,
            catalogGuid,
            onlyRootCategories: true,
        };

        socket.emit(EndpointsEnum.CategoriesGetCategories, payload);
    };

    const renderPackQty = (packQty: number) => {
        if (!_.isNumber(packQty)) {
            return "--";
        }

        return <FormattedNumber value={packQty} minimumFractionDigits={0} maximumFractionDigits={0} />;
    };

    const showInProductionSidebar = (row: ICatalog_Item) => {
        const sidebar = (
            <InventoryItemInProductionDetailSidebar
                catalogItem={row}
                closeFn={() => {
                    uiContext.toggleSidebar(false);
                    uiContext.setSidebarComponent(null);
                }}
            />
        );

        uiContext.setSidebarComponent(sidebar);
        uiContext.toggleSidebar(true);
    };

    const renderQtyInProduction = (row: ICatalog_Item) => {
        if (row.qty_in_production) {
            let showViewButton = false;

            if (userModel.isSupplierUser) {
                if (
                    userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.ADMIN ||
                    userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.INVENTORY_MGMT
                ) {
                    showViewButton = true;
                }
            }

            return (
                <div>
                    {/* Serial counts are whole units; no qty_precision formatting */}
                    <FormattedNumber value={row.qty_in_production} minimumFractionDigits={0} />
                    {showViewButton && (
                        <OwIconButton
                            iconClass="fas fa-magnifying-glass ms-2"
                            iconColorClass="text-primary"
                            fn={() => {
                                showInProductionSidebar(row);
                            }}
                            title="View In Production"
                        />
                    )}
                </div>
            );
        }

        return "--";
    };

    const showQtyIncomingSidebar = (row: ICatalog_Item) => {
        const sidebar = (
            <InventoryItemIncomingQtyDetailSidebar
                catalogItem={row}
                closeFn={() => {
                    uiContext.toggleSidebar(false);
                    uiContext.setSidebarComponent(null);
                }}
            />
        );

        uiContext.setSidebarComponent(sidebar);
        uiContext.toggleSidebar(true);
    };

    const renderQtyIncoming = (row: ICatalog_Item) => {
        if (row.qty_incoming) {
            let showViewButton = false;

            if (userModel.isSupplierUser) {
                if (
                    userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.ADMIN ||
                    userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.INVENTORY_MGMT
                ) {
                    showViewButton = true;
                }
            }

            return (
                <div>
                    <FormattedNumber value={row.qty_incoming} minimumFractionDigits={supplierModel.qty_precision} />
                    {showViewButton && (
                        <OwIconButton
                            iconClass="fas fa-magnifying-glass ms-2"
                            iconColorClass="text-primary"
                            fn={() => {
                                showQtyIncomingSidebar(row);
                            }}
                            title="View Qty Incoming"
                        />
                    )}
                </div>
            );
        }

        return "--";
    };

    const renderQtyHeldForBackorders = (row: ICatalog_Item) => {
        if (row.qty_held_for_backorders) {
            return <FormattedNumber value={row.qty_held_for_backorders} minimumFractionDigits={supplierModel.qty_precision} />;
        }

        return "--";
    };

    const showQtyBackorderedSidebar = (row: ICatalog_Item) => {
        const sidebar = (
            <InventoryItemBackorderedQtyDetailSidebar
                catalogItem={row}
                closeFn={() => {
                    uiContext.toggleSidebar(false);
                    uiContext.setSidebarComponent(null);
                }}
            />
        );

        uiContext.setSidebarComponent(sidebar);
        uiContext.toggleSidebar(true);
    };

    const renderQtyBackordered = (row: ICatalog_Item) => {
        if (row.qty_backordered) {
            let showViewButton = false;

            if (userModel.isSupplierUser) {
                if (
                    userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.ADMIN ||
                    userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.INVENTORY_MGMT
                ) {
                    showViewButton = true;
                }
            }

            return (
                <div>
                    <FormattedNumber value={row.qty_backordered} minimumFractionDigits={supplierModel.qty_precision} />
                    {showViewButton && (
                        <OwIconButton
                            iconClass="fas fa-magnifying-glass ms-2"
                            iconColorClass="text-primary"
                            fn={() => {
                                showQtyBackorderedSidebar(row);
                            }}
                            title="View Qty Backordered"
                        />
                    )}
                </div>
            );
        }

        if (row.allow_backorder) {
            return "--";
        } else {
            return "N/A";
        }
    };

    const renderBackorderLimit = (row: ICatalog_Item) => {
        if (row.allow_backorder && row.backorder_limit) {
            return <FormattedNumber value={row.backorder_limit} minimumFractionDigits={supplierModel.qty_precision} />;
        }

        return "--";
    };

    const showReservedQtyOnHandSidebar = (row: ICatalog_Item) => {
        const sidebar = (
            <InventoryItemReservedQtyOnHandDetailSidebar
                catalogItem={row}
                closeFn={() => {
                    uiContext.toggleSidebar(false);
                    uiContext.setSidebarComponent(null);
                }}
            />
        );

        uiContext.setSidebarComponent(sidebar);
        uiContext.toggleSidebar(true);
    };

    const renderReservedQtyOnHand = (row: ICatalog_Item, rowIndex: number, isDetailViewRow?: boolean, parentRowIndex?: number) => {
        let warehouseDetail: any = null;

        if (supplierModel.has_warehouses && row.Warehouse_Catalog_Items_Maps) {
            let reservedQtyOnHand = 0;

            warehouseDetail = row.Warehouse_Catalog_Items_Maps.filter(isVisibleWarehouseMap)
                // .filter((mapDetail) => mapDetail.qty_on_hand > 0)
                .map((mapDetail) => {
                    reservedQtyOnHand += mapDetail.reserved_qty_on_hand || 0;
                    return (
                        <tr key={mapDetail.guid}>
                            <th>{renderWarehouseName(mapDetail)}</th>
                            <td>{mapDetail.reserved_qty_on_hand || "--"}</td>
                        </tr>
                    );
                });

            let tableClass = "table mt-2";

            if (!UIService.isMainViewLight()) {
                tableClass += " table-dark";
            }

            warehouseDetail = <table className={tableClass}>{warehouseDetail}</table>;

            return (
                <div>
                    <div>{reservedQtyOnHand}</div>
                    <div>{warehouseDetail}</div>
                </div>
            );
        } else {
            if (!_.isNumber(row.reserved_qty_on_hand)) {
                return "--";
            }

            let showViewButton = false;

            if (userModel.isSupplierUser) {
                if (
                    userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.ADMIN ||
                    userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.INVENTORY_MGMT
                ) {
                    showViewButton = true;
                }
            }

            return (
                <div>
                    <FormattedNumber value={row.reserved_qty_on_hand} minimumFractionDigits={supplierModel.qty_precision} />
                    {showViewButton && (
                        <OwIconButton
                            iconClass="fas fa-magnifying-glass ms-2"
                            iconColorClass="text-primary"
                            fn={() => {
                                showReservedQtyOnHandSidebar(row);
                            }}
                            title="View Reserved Qty On Hand"
                        />
                    )}
                </div>
            );
        }
    };

    const renderPriceGroup = (row: ICatalog_Item, rowIndex: number) => {
        const pricing = row.pricing;

        let { priceGroupName } = getPriceGroupFromCatalogGuid();

        if (!priceGroupName.length && priceGroup) {
            priceGroupName = getPriceGroupFromPriceGroupId(priceGroup.id, false) as string;
        }

        // console.log("renderPriceGroup", pricing, priceGroupName);

        let price = 0;

        if (pricing[priceGroupName]) {
            price = pricing[priceGroupName];
        } else if (pricing[priceGroupName.toLowerCase()]) {
            price = pricing[priceGroupName.toLowerCase()];
        }

        if (pricing && priceGroupName) {
            let prefix = "$";

            if (currencyConversion) {
                let currency = row?.Catalog?.Currency ? row.Catalog.Currency : undefined;

                if (vendorModel.Currency) {
                    currency = vendorModel.Currency;
                }

                prefix = currency ? OrderEntryService.getCurrencySymbol(currency.name) : "$";

                if (currency && row?.Catalog?.Currency) {
                    price = OrderEntryService.convertCurrency(price, row.Catalog?.Currency, currency);
                }
            }

            return (
                <NumericFormat
                    value={price}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={supplierModel.pricing_precision || 2}
                    fixedDecimalScale={true}
                    prefix={prefix}
                />
            );
        }
    };

    const renderMap = (row: ICatalog_Item, rowIndex: number, isDetailViewRow?: boolean, parentRowIndex?: number) => {
        if (supplierModel.has_map) {
            let mapPrice = row.map || 0;

            let prefix = "$";

            if (currencyConversion) {
                let currency = row?.Catalog?.Currency ? row.Catalog.Currency : undefined;

                if (vendorModel.Currency) {
                    currency = vendorModel.Currency;
                }

                prefix = currency ? OrderEntryService.getCurrencySymbol(currency.name) : "$";

                if (currency && row?.Catalog?.Currency) {
                    mapPrice = OrderEntryService.convertCurrency(mapPrice, row.Catalog?.Currency, currency);
                }
            }

            return (
                <NumericFormat
                    value={mapPrice}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={supplierModel.pricing_precision || 2}
                    fixedDecimalScale={true}
                    prefix={prefix}
                />
            );
        }
    };

    const renderSkuCol = (row: ICatalog_Item) => {
        return (
            <div>
                <div className={"mb-2"}>{row.sku}</div>
                {row.is_ordered_on_demand ? <OwPill title={"ordered_on_demand"} className={"text-small no-wrap"} /> : null}
                {uiContext.showHiddenFeatures && (
                    <div>
                        <div>
                            ID: <ClickToCopy text={row.id.toString()} />
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const renderDescriptionCol = (row: ICatalog_Item) => {
        return (
            <div>
                <div className={"mb-2"}>{row.short_description}</div>
                <DescriptionExpander catalogItem={row} />
            </div>
        );
    };

    const renderMsrp = (row: ICatalog_Item, rowIndex: number, isDetailViewRow?: boolean, parentRowIndex?: number) => {
        let msrpPrice = row.msrp || 0;

        let prefix = "$";

        if (currencyConversion) {
            let currency = row?.Catalog?.Currency ? row.Catalog.Currency : undefined;

            if (vendorModel.Currency) {
                currency = vendorModel.Currency;
            }

            prefix = currency ? OrderEntryService.getCurrencySymbol(currency.name) : "$";

            if (currency && row?.Catalog?.Currency) {
                msrpPrice = OrderEntryService.convertCurrency(msrpPrice, row.Catalog?.Currency, currency);
            }
        }

        return (
            <NumericFormat
                value={msrpPrice}
                displayType={"text"}
                thousandSeparator={true}
                decimalScale={supplierModel.pricing_precision || 2}
                fixedDecimalScale={true}
                prefix={prefix}
            />
        );
    };

    const renderLocation = (row: ICatalog_Item, rowIndex: number, isDetailViewRow?: boolean, parentRowIndex?: number) => {
        if (supplierModel.has_warehouses) {
            let warehouseDetail: any = null;

            if (row.Warehouse_Catalog_Items_Maps) {
                let hasRowBinData = false;

                warehouseDetail = row.Warehouse_Catalog_Items_Maps.filter(isVisibleWarehouseMap).map((mapDetail) => {
                    let location = (mapDetail.row || "").trim();

                    if (mapDetail.bin) {
                        if (location.length) {
                            location += `- ${mapDetail.bin}`;
                        } else {
                            location = (mapDetail.bin || "").trim();
                        }
                    }

                    if (location.length) {
                        hasRowBinData = true;
                    }

                    return (
                        <tr key={mapDetail.guid}>
                            <th>{renderWarehouseName(mapDetail)}</th>
                            <td>{location}</td>
                        </tr>
                    );
                });

                if (hasRowBinData) {
                    let tableClass = "table mt-2";

                    if (!UIService.isMainViewLight()) {
                        tableClass += " table-dark";
                    }

                    warehouseDetail = <table className={tableClass}>{warehouseDetail}</table>;
                } else {
                    warehouseDetail = null;
                }
            }

            return warehouseDetail;
        } else {
            if (row.row || row.bin) {
                let location = row.row || "";

                if (row.bin?.length) {
                    location = `${location} - ${row.bin}`;
                }

                return location;
            } else {
                return "--";
            }
        }
    };

    const renderPurchaseLink = (row: ICatalog_Item, rowIndex: number, isDetailViewRow?: boolean, parentRowIndex?: number) => {
        if (row.purchase_link) {
            return (
                <a href={row.purchase_link} target="_blank" className={"pointer"} rel="noreferrer">
                    <OwLabel title={"link"} className={"pointer"} />
                </a>
            );
        } else {
            return "";
        }
    };

    const performSearch = (resetSearch?: boolean) => {
        setOffset(0);
        setLimit(25);
        getStockLevels("performSearch", resetSearch);
    };

    const getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            onlyActive: true,
            callMeta: {
                view: "Inventory",
                fn: "getCatalogs",
            },
        };

        if (!userModel?.isSupplierUser) {
            payload.vendorGuid = vendorModel.guid;
        }

        socket.emit(EndpointsEnum.CatalogsGetCatalogs, payload);
    };

    const getSupplierTokens = () => {
        const data: IGetAllSupplierTokensDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        socket.emit(EndpointsEnum.TokenGetAllSupplierTokens, data);
    };

    const getWarehouses = () => {
        const payload: IGetWarehousesDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        socket.emit(EndpointsEnum.WarehouseGetWarehouses, payload);
    };

    const handleChange = (e: any) => {
        // e?.stopPropagation();
        // e?.preventDefault();

        if (e.key === "Enter" && scanMode) {
            performSearch();
            return;
        }

        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;

        switch (e.target.name) {
            case "selectedCategory":
                {
                    const foundCategory = categories.find((category) => category.guid === value);
                    setSelectedCategory(foundCategory);
                }
                break;

            case "catalogGuid":
                setSelectedCategory(undefined);
                setCatalogGuid(value);
                break;

            case "stock":
                setStock(value);
                break;

            case "name":
                setName(value);
                break;

            case "priceRangeStart":
                setPriceRangeStart(value);
                break;

            case "priceRangeEnd":
                setPriceRangeEnd(value);
                break;

            case "priceGroup":
                {
                    const foundPriceGroup = priceGroups.find((priceGroup) => priceGroup.guid === value);
                    if (foundPriceGroup) {
                        setPriceGroup(foundPriceGroup);
                    }
                }
                break;
        }
        // if (name === "catalog" || name === "price_group") {
        //     if (_.isNil(value) || !value.length) {
        //         state[name] = null;
        //     }
        // }
        //
        // if (name === "catalog" && (!value || !value.length)) {
        //     state.price_group = null;
        //     state.priceGroups = [];
        // }

        // setState(state, () => {
        //     if (name === "catalogGuid") {
        //         const priceGroup = getPriceGroupFromCatalogGuid(true) as IPrice_Group;
        //
        //         setState({
        //             priceGroupGuid: priceGroup.guid,
        //         });
        //     }
        //
        //     if (name === "catalog") {
        //         const catalog = _.find(state.catalogs, (catalog) => {
        //             // @ts-expect-error
        //             return parseInt(catalog.id) === parseInt(value);
        //         }) as ICatalog;
        //
        //         if (!catalog) {
        //             return;
        //         }
        //
        //         let priceGroups = _.get(catalog, "Price_Groups", []);
        //         priceGroups = _.isNil(priceGroups) ? [] : priceGroups;
        //
        //         let isValidCategorySelection = true;
        //
        //         if (catalog.reqd_order_categories) {
        //             isValidCategorySelection = false;
        //         }
        //
        //         let price_group = state.price_group;
        //
        //         if (!userModel?.isSupplierUser && supplierModel?.hide_vendor_price_group_select) {
        //             price_group = priceGroups[0].id;
        //         }
        //
        //         setState({ priceGroups, price_group });
        //     }
        // });
    };

    const enterSearch = (e: any) => {
        if (e.key === "Enter") {
            getStockLevels("enterSearch");
        }
    };

    const getStockLevels = (callingFn: string, resetSearch?: boolean) => {
        // console.log("getStockLevels called from:", callingFn, "catalogGuid:", catalogGuid);

        if (catalogGuid) {
            const payload: IGetStockLevelsDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                stock,
                catalogGuid,
                limit,
                offset,
                sortCol,
                sortOrder: sortOrder || SortOrderEnum.ASC,
            };

            if (!userModel?.isSupplierUser) {
                payload.vendorGuid = vendorModel.guid;
            }

            // console.log(`getStockLevels ${callingFn} - resetSearch:`, resetSearch);

            if (!resetSearch) {
                if (name?.length) {
                    payload.name = name;
                }

                if (manufacturer?.length) {
                    payload.manufacturer = manufacturer;
                }

                if (selectedCategory) {
                    payload.categoryGuid = selectedCategory.guid;
                    payload.includeSubcategories = true;
                }

                const priceRange: IPriceRangeFilter = {};
                let hasPriceRange = false;

                if (priceRangeStart) {
                    priceRange.minPrice = priceRangeStart;
                    hasPriceRange = true;
                }

                if (priceRangeEnd) {
                    priceRange.maxPrice = priceRangeEnd;
                    hasPriceRange = true;
                }

                if (hasPriceRange) {
                    payload.priceRange = priceRange;
                }

                if (priceGroup) {
                    payload.priceGroupGuid = priceGroup.guid;
                }
            }

            if (supplierModel.allow_inventory_screen_order) {
                if (priceGroup) {
                    payload.priceGroupGuid = priceGroup.guid;
                } else {
                    const { priceGroupDetail } = getPriceGroupFromCatalogGuid(true);

                    if (priceGroupDetail) {
                        payload.priceGroupGuid = priceGroupDetail.guid;
                    }
                }
            }

            if (resetSearch) {
                payload.offset = 0;
                payload.limit = 25;
            }

            socket.emit(EndpointsEnum.CatalogsGetStockLevels, payload);

            setStockLevelsBtnActive(true);
            setIsDataFetching(true);
            setHasPaginationChange(false);
        }
    };

    useEffect(() => {
        if (hasPaginationChange) {
            getStockLevels("paginationChanged");
        }
    }, [hasPaginationChange]);

    const showChevronFn = (row: Partial<ICatalog_ItemUI>): boolean => {
        if (row.has_alternate_sourcing) {
            return true;
        } else {
            return false;
        }
    };

    const parseLastUpdated = (date: any) => {
        return UserService.parseLastUpdated(date);
    };

    const paginationChanged = (_offset: number, _limit: number) => {
        setOffset(_offset);
        setLimit(_limit);
        setHasPaginationChange(true);
    };

    const resetFilters = () => {
        const _outOfStockOnly = getOutOfStockOnly();

        setName("");
        setManufacturer("");
        setStock(_outOfStockOnly ? "out_of_stock_only" : "all");
        setLimit(25);
        setOffset(0);
        setTotalCatalogItems(0);
        setCatalogItems([]);
        setSelectedCategory(undefined);
        setPriceRangeStart(null);
        setPriceRangeEnd(null);

        getStockLevels("resetFilters", true);
    };

    const getCatalogCSVInventory = () => {
        if (catalogGuid) {
            const payload: IGetCatalogCSVInventoryDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                catalogGuid,
            };

            socket.emit(EndpointsEnum.CatalogsGetCatalogCSVInventory, payload);

            setActiveInventoryCsvBtn(true);
        }
    };

    const showModal = () => {
        if (!catalogGuid) {
            return;
        }

        const catalogModel = catalogs.find((_catalog) => {
            return _catalog.guid === catalogGuid;
        });

        const _modalComponent = (
            <CatalogUploadUpdateModal
                closeModalFn={hideModal}
                socket={socket}
                userModel={userModel}
                supplierModel={supplierModel}
                catalogModel={catalogModel}
                notifyFn={uiContext.notifyFn}
                isInventoryOnly={true}
            />
        );

        setIsModalOpen(true);
        setModalComponent(_modalComponent);
    };

    const hideModal = () => {
        setIsModalOpen(false);
        setModalComponent(null);
    };

    const afterOpenModal = () => {};

    const closeModal = () => {
        performSearch();
    };

    const chevronToggleCallbackFn = (rowIndex: number) => {
        const _catalogItems = [...catalogItems];

        const catalogItem = _catalogItems[rowIndex];

        if (catalogItem.has_alternate_sourcing) {
            const alternates = catalogItem.Catalog_Item_Product_Source_Maps || [];

            const items = alternates.map((alternate) => {
                return alternate.Source_Catalog_Item;
            });

            setDetailViewData(items);
        }
    };

    const cancelSidebar = (refreshData?: boolean) => {
        uiContext.toggleSidebar(false);
    };

    const showSidebar = () => {
        if (catalog && priceGroup) {
            const selectedCatalog = catalogs.find((_catalog) => {
                return _catalog.guid === catalogGuid;
            });
            const selectedPriceGroup = priceGroups.find((_priceGroup) => {
                return _priceGroup.guid === priceGroupGuid;
            });

            const sidebar = (
                <InventoryCartSidebar
                    cancelFn={cancelSidebar}
                    userModel={userModel}
                    supplierModel={supplierModel}
                    vendorModel={vendorModel}
                    cartItems={cartItems}
                    updateCartItems={updateCartItems}
                    socket={socket}
                    catalogGuid={catalog?.guid}
                    priceGroupGuid={priceGroup?.guid}
                    notifyFn={uiContext.notifyFn}
                    selectedVendor={selectedVendor}
                    selectedCatalog={catalog}
                    selectedPriceGroup={priceGroup}
                    history={navigate}
                />
            );

            uiContext.setSidebarComponent(sidebar);

            uiContext.toggleSidebar(true);
        }
    };

    const closeItemDetailView = (refresh?: boolean) => {
        setMobileViewComponent(null);

        if (refresh) {
            getStockLevels("closeItemDetailView");
        }
    };

    const showItemDetailView = (item: ICatalog_Item) => {
        const component = (
            <InventoryItemMobileDetailView
                item={item}
                closeFn={closeItemDetailView}
                saveFn={saveAdjustment}
                supplierModel={supplierModel}
            />
        );

        setMobileViewComponent(component);
    };

    const saveColumnsAsDefault = (columns: IColumns, sortCol?: string, sortOrder?: SortOrderEnum, fixedHeader?: boolean) => {
        const payload: IUpdateTokenSettingsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            settings: {
                inventory_cols: columns,
                inventory_fixed_header: fixedHeader,
            },
            tokenGuid: userModel.supplierUserToken?.guid || userModel.vendorUserToken?.guid || "",
        };

        if (!userModel.isSupplierUser) {
            payload.vendorGuid = vendorModel.guid;
        }

        socket.emit(EndpointsEnum.TokenUpdateSettings, payload);

        // Update local tableConfig with the new sticky header setting
        setTableConfig({ ...tableConfig, stickyHeader: fixedHeader || false });
    };

    const currencyConversionSection = supplierModel.has_currency_conversions ? (
        <div className={"d-flex align-items-center"}>
            <OwToggle
                fn={toggleCurrencyConversion}
                name={"currency"}
                label={"currency_conversions"}
                active={currencyConversion}
                labelOnRight={true}
            />
        </div>
    ) : null;

    const scanModeSection = (
        <div className={"d-flex align-items-center"}>
            <OwToggle fn={toggleScanMode} name={"scan_mode"} label={"scan_mode"} active={scanMode} labelOnRight={true} />
        </div>
    );

    const includeVehiclesSection =
        supplierModel.has_truck_inventory && supplierModel.has_warehouses ? (
            <div className={"d-flex align-items-center"}>
                <OwToggle
                    fn={toggleIncludeVehicles}
                    name={"include_vehicles"}
                    label={"include_vehicles"}
                    active={includeVehicles}
                    labelOnRight={true}
                />
            </div>
        ) : null;

    const viewCartSection = supplierModel?.allow_inventory_screen_order ? (
        <div className={"ms-auto"}>
            <OwButton
                title={"view_cart"}
                leftIconClass={"fad fa-shopping-cart"}
                fn={viewCart}
                postTitle={` (${cartItems.length})`}
                disabled={!catalog || !priceGroup}
            />
        </div>
    ) : null;

    const csvActionsSection =
        userModel?.isSupplierUser &&
        (userModel?.supplierUserToken?.user_type_id === UserTypesEnum.ADMIN ||
            userModel.supplierUserToken?.user_type_id === UserTypesEnum.INVENTORY_MGMT) ? (
            <Dropdown>
                <Dropdown.Toggle size="sm" variant="secondary" id="csv-actions-dropdown">
                    <i className="fas fa-file-csv me-2"></i>
                    CSV Actions
                </Dropdown.Toggle>
                <Dropdown.Menu className={UIService.isMainViewLight() ? "" : "bg-secondary"}>
                    <Dropdown.Item className="bg-primary text-white" onClick={getCatalogCSVInventory}>
                        <i className="fas fa-download me-2"></i>
                        Download CSV
                    </Dropdown.Item>
                    {canEditAccess && !supplierModel.inventory_screen_read_only && (
                        <Dropdown.Item className="bg-danger text-white" onClick={showModal}>
                            <i className="fas fa-upload me-2"></i>
                            Upload CSV
                        </Dropdown.Item>
                    )}
                </Dropdown.Menu>
            </Dropdown>
        ) : null;

    const backorderAllocationSection = () => {
        let showButton = false;

        if (userModel.isSupplierUser) {
            if (
                userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.ADMIN ||
                userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.INVENTORY_MGMT ||
                userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.SHIP_MGMT
            ) {
                showButton = true;
            }
        }

        if (catalog?.guid && showButton) {
            return (
                <OwButton
                    title={"backorder_allocation"}
                    leftIconClass={"fas fa-truck-loading"}
                    fn={() => navigate(`/inventory/backorders/${catalog.guid}`)}
                    className="btn-sm btn-primary"
                />
            );
        }
        return null;
    };

    return (
        <div className={"Inventory pb-5 pb-md-0"}>
            {/*<Breadcrumbs navItems={navItems} />*/}

            <div className={"row mt-2"}>
                <div className={"col-12 d-flex flex-column align-items-center"}>
                    <OwTitle title={"inventory"} leftIconName={"fad fa-inventory"} className={"me-auto"} />

                    {inventoryViewMode === "standard" && (
                        <div className={"d-flex ms-auto d-print-none align-items-end mb-2"}>
                            <ControlBar
                                name={"inventory_controls"}
                                sections={[
                                    {
                                        name: "backorder_allocation",
                                        elements: [backorderAllocationSection()],
                                    },
                                    {
                                        name: "csv_actions",
                                        elements: [csvActionsSection],
                                    },
                                    {
                                        name: "toggles",
                                        elements: [currencyConversionSection, scanModeSection, includeVehiclesSection],
                                    },
                                    {
                                        name: "view_cart",
                                        elements: [viewCartSection],
                                    },
                                ]}
                            />
                        </div>
                    )}
                </div>
            </div>

            {canViewByCustomer && (
                <div className={"d-flex d-print-none mb-2"}>
                    <div className={"btn-group"}>
                        <OwButton
                            title={"standard"}
                            className={"btn-sm btn-primary " + (inventoryViewMode === "standard" ? "active" : "")}
                            fn={() => setInventoryViewMode("standard")}
                        />
                        <OwButton
                            title={"by_customer"}
                            className={"btn-sm btn-primary " + (inventoryViewMode === "by_customer" ? "active" : "")}
                            fn={() => setInventoryViewMode("by_customer")}
                        />
                    </div>
                </div>
            )}

            {canViewByCustomer && inventoryViewMode === "by_customer" && <InventoryByCustomerView />}

            {inventoryViewMode === "standard" && userModel?.isSupplierUser && supplierModel?.allow_inventory_screen_order ? (
                <div className="mb-2">
                    <div className={"card " + (UIService.isMainViewLight() ? "" : "dark-card text-white bg-secondary")}>
                        <div className="card-body">
                            <InventoryAccountSelection
                                cartItems={cartItems}
                                catalogs={catalogs}
                                setCatalog={(_catalog: ICatalog | null) => {
                                    setCatalog(_catalog);
                                    if (_catalog) {
                                        setCatalogGuid(_catalog.guid);
                                    } else {
                                        setCatalogGuid(undefined);
                                        setCatalogItems([]);
                                    }
                                }}
                                setPriceGroup={setPriceGroup}
                                setSelectedVendor={setSelectedVendor}
                            />
                        </div>
                    </div>
                </div>
            ) : null}

            {inventoryViewMode === "standard" && (
                <>
                    <div className={"mb-2"}>
                        <SearchSection>
                            <div className={"row mb-2 align-items-end"}>
                                {!supplierModel.allow_inventory_screen_order && (
                                    <div className={"mb-2 mb-md-0 col-12 col-sm-6 col-md-3 col-lg-2"}>
                                        <OwLabel title={"catalog"} />
                                        <OwSelectOption
                                            options={catalogs}
                                            valueProp={"guid"}
                                            titleProp={"name"}
                                            fn={handleChange}
                                            name={"catalogGuid"}
                                            selectedOption={catalogGuid}
                                            hasSelectedOptionProp={false}
                                            emitOnLoad={true}
                                            emitTarget={true}
                                            isDisabled={
                                                !!cartItems.length || !!selectedVendor || supplierModel.allow_inventory_screen_order
                                            }
                                            showBlankFirst={true}
                                        />
                                    </div>
                                )}

                                {!supplierModel.allow_inventory_screen_order && (
                                    <div className={"mb-2 mb-md-0 col-12 col-sm-6 col-md-3 col-lg-2"}>
                                        <OwLabel title={"price_group"} />
                                        <OwSelectOption
                                            name="priceGroup"
                                            options={priceGroups}
                                            selectedOption={priceGroup}
                                            selectedOptionProp={"guid"}
                                            titleProp={"value"}
                                            valueProp={"guid"}
                                            fn={handleChange}
                                            isDisabled={supplierModel.allow_inventory_screen_order}
                                        />
                                    </div>
                                )}

                                <div className={"mb-2 mb-md-0 col-12 col-sm-6 col-md-3 col-lg-2"}>
                                    <OwLabel title={"search"} />
                                    <OwInputWrapper
                                        name={"name"}
                                        fn={handleChange}
                                        placeholder={"name_sku_description"}
                                        value={name}
                                        onKeyDownFn={enterSearch}
                                    />
                                </div>

                                <div className={"col-12 col-sm-4 col-md-auto"}>
                                    <OwLabel title={"stock"} />
                                    <OwSelectOption
                                        name={"stock"}
                                        options={[
                                            { value: "all", title: "all" },
                                            { value: "in_stock_only", title: "in_stock_only" },
                                            { value: "out_of_stock_only", title: "out_of_stock_only" },
                                        ]}
                                        selectedOption={stock}
                                        hasSelectedOptionProp={false}
                                        fn={handleChange}
                                        valueProp={"value"}
                                        titleProp={"title"}
                                        translateTitle={true}
                                    />
                                    {/*<OwCheckbox*/}
                                    {/*    labelClassName={"mb-2 mb-md-0 me-2"}*/}
                                    {/*    fn={handleChange}*/}
                                    {/*    className={""}*/}
                                    {/*    name={"outOfStockOnly"}*/}
                                    {/*    label={"out_of_stock_only"}*/}
                                    {/*    checked={state.outOfStockOnly}*/}
                                    {/*/>*/}
                                </div>

                                <div className={"col-12 col-sm-4 col-md-auto"}>
                                    <OwLabel title={"manufacturer"} />
                                    <OwInputWrapper
                                        name={"manufacturer"}
                                        fn={handleChange}
                                        placeholder={"manufacturer"}
                                        value={manufacturer}
                                    />
                                </div>

                                <div className={"col-12 col-sm-4 col-md-auto"}>
                                    <OwLabel title={"category"} />
                                    <OwHierarchicalCategorySelector
                                        categories={categories}
                                        value={selectedCategory}
                                        onChange={(category) => setSelectedCategory(category)}
                                        placeholder="select_category"
                                        userModel={userModel}
                                        supplierModel={supplierModel}
                                        vendorModel={vendorModel}
                                    />
                                </div>

                                {priceGroup && (
                                    <div className={"col-12 col-sm-4 col-md-auto"}>
                                        <OwLabel title={"price_range"} />
                                        <div className={"d-flex"}>
                                            <OwFnInput
                                                name="priceRangeStart"
                                                fn={handleChange}
                                                placeholder="price_range_start"
                                                value={priceRangeStart}
                                                onKeyDownFn={enterSearch}
                                                type="number"
                                                min={0}
                                                max={1000000}
                                                step={1}
                                                showStep={true}
                                                isSmall={true}
                                            />
                                            <div className="mx-2">-</div>
                                            <OwFnInput
                                                name="priceRangeEnd"
                                                fn={handleChange}
                                                placeholder="price_range_end"
                                                value={priceRangeEnd}
                                                onKeyDownFn={enterSearch}
                                                type="number"
                                                min={0}
                                                max={1000000}
                                                step={1}
                                                showStep={true}
                                                isSmall={true}
                                            />
                                        </div>
                                    </div>
                                )}

                                <div className={"col-auto mt-2 mt-md-0"}>
                                    <OwButton
                                        fn={() => {
                                            performSearch(false);
                                        }}
                                        title={"search"}
                                        active={stockLevelsBtnActive}
                                        disabled={stockLevelsBtnActive}
                                    />
                                    <OwButton
                                        className={"btn-sm btn-danger ms-2"}
                                        fn={resetFilters}
                                        title={"reset"}
                                        disabled={stockLevelsBtnActive}
                                    />
                                </div>
                            </div>
                        </SearchSection>
                    </div>

                    <div>
                        <OwActionBar
                            columns={viewColumns}
                            colToggledFn={setViewColumns}
                            toggleSmallTable={() => {}}
                            hideTableTypeSelect={true}
                            saveAsDefaultsFn={saveColumnsAsDefault}
                            showFixedHeader={true}
                            fixedHeader={tableConfig.stickyHeader}
                        />
                    </div>

                    <div className={"table-responsive d-none d-md-flex"}>
                        {/*<OwFnTable*/}
                        {/*    columns={columns}*/}
                        {/*    dataSet={catalogItems}*/}
                        {/*    dataFetch={isDataFetching}*/}
                        {/*    initialData={isInitialData}*/}
                        {/*    tableConfig={tableConfig}*/}
                        {/*    currentSortCol={sortCol}*/}
                        {/*    wrappingClassName={"w-100"}*/}
                        {/*    rowKeyProp={"guid"}*/}
                        {/*/>*/}
                        {/* Using the OwFnTable causes a flickering in the UI anytime a search field is changed by the user. */}
                        <OwTable
                            wrappingClassName={"w-100"}
                            currentSortCol={sortCol}
                            columns={columns}
                            dataSet={catalogItems}
                            detailViewColumns={detailViewColumns}
                            // detailViewDataSet={state.detailViewData}
                            detailViewDataSetProp={"Catalog_Item_Product_Source_Maps"}
                            detailViewDataSetSubProp={"Source_Catalog_Item"}
                            detailViewInitialData={false}
                            detailViewDataFetch={false}
                            userModel={userModel}
                            supplierModel={supplierModel}
                            dataFetch={isDataFetching}
                            initialData={isInitialData}
                            tableConfig={tableConfig}
                            chevronToggleCallbackFn={chevronToggleCallbackFn}
                            rowKeyProp={"guid"}
                        />
                    </div>

                    <div className={"d-flex d-md-none"}>
                        <InventoryMobileRows dataSet={catalogItems} showItemDetailView={showItemDetailView} />
                    </div>

                    {mobileViewComponent ? mobileViewComponent : null}

                    {catalogItems && catalogItems.length ? (
                        <PaginationBar
                            offset={offset}
                            limit={limit}
                            totalRecords={totalCatalogItems}
                            onPaginationChanged={paginationChanged}
                        />
                    ) : null}
                </>
            )}

            <div>
                <Modal
                    isOpen={isModalOpen}
                    onAfterOpen={afterOpenModal}
                    onRequestClose={closeModal}
                    onAfterClose={closeModal}
                    contentLabel="Orderwerks"
                    shouldCloseOnOverlayClick={false}
                    className={"modalContentClass"}
                    overlayClassName={"modalOverlayClass"}
                    style={modalStyle}>
                    {modalComponent}
                </Modal>
            </div>
        </div>
    );
};
